import { ActiveProduct, Variant } from "@/types/types";
import productQuery from "@/queries/activeAndRetiredProductsQuery.graphql";
import { print } from "graphql/index";
import { GraphQLClient } from "graphql-request";
import { GetByProductIdsQuery } from "@/queries/activeAndRetiredProductsQuery.AUTOMATICALLY_GENERATED_DO_NOT_EDIT";

const graphQLClient = (prodcatEndpoint: string, prodcatApiKey: string) => {
  return new GraphQLClient(prodcatEndpoint, {
    headers: { "x-api-key": prodcatApiKey },
    // force graphql-request to use native fetch
    fetch,
  });
};

export const getGiftProductData = async (
  pimProductId: string,
  prodcatEndpoint: string,
  prodcatApiKey: string,
): Promise<ActiveProduct | undefined> => {
  if (
    prodcatEndpoint.length > 0 &&
    prodcatApiKey.length > 0 &&
    pimProductId.length > 0
  ) {
    const { data } = await graphQLClient(
      prodcatEndpoint,
      prodcatApiKey,
    ).rawRequest<GetByProductIdsQuery>(print(productQuery), {
      id: [pimProductId],
    });

    if (data.activeAndRetiredProducts.activeProducts.length === 0) {
      return undefined;
    }

    const simpleProduct = data.activeAndRetiredProducts.activeProducts[0];

    const productHasServices = (variant: Variant | undefined) => {
      return variant ? variant?.services?.length !== 0 : false;
    };

    const product =
      data.activeAndRetiredProducts.activeProducts.length === 1 &&
      !productHasServices(simpleProduct?.variants[0])
        ? simpleProduct
        : undefined;

    return product;
  } else {
    return undefined;
  }
};
